<p>camping-details-dialog works!</p>
